
































































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'
import Carousel from '@ui/Carousel'

settings =
  name: "EventInfoForCard"

  vue:
    props: ['event', 'actions','options']
    components: { Carousel }

    computed:
      instanceEvents: -> @ctxEventInstances(@event)
      instanceEventsCount: -> @instanceEvents.length - 1
      hasOnlyOneInstance: -> (@instanceEvents.length - 1) is 0
      isSameDay: -> @event.local_start_day is @event.local_end_day
      host: -> @ctxHost(@event)
      selectedSpace: ->
        space = null
        for k,v of @event.spaces
          space ||= v if v.type is @selectedSpaceType
        space
      selectedSpaceType: -> @options?.selectedSpaceType
      typeIsProductSampling: -> @selectedSpace?.type is 'product_sampling'
      typeIsLiveStream: -> @selectedSpace?.type is 'native_integration'
      typeIsSocialPost: -> @selectedSpace?.type is 'social_media_post'
      eventTypes: -> @event?.types || []
      publicTags: -> @event?.public_tags || []
      privateTags: -> @event?.private_tags || []
      featuredEventIds: -> @options?.campaign?.featured_event_ids || []
      favoriteEventSetIds: -> @options?.campaign?.favorite_event_set_ids || []
      recentlyPublishedEventIds: -> @options?.campaign?.recently_published_event_ids || []

      hasFavoriteActions: -> @actions?.favoriteEventTrigger? and @actions?.unfavoriteEventTrigger?
      isRecommended: -> @event?.event_set_id in @options?.campaign?.recommended_event_set_ids if @options?.campaign?.recommended_event_set_ids
      isFavorited: -> @event?.event_set_id in @favoriteEventSetIds
      isStaffPick: -> @event?.id in @featuredEventIds
      isRecentlyPublished: -> @event?.id in @recentlyPublishedEventIds

      cardImages: ->
        images = []
        for image in @ctxImages(@event)
          url = image.hero_url || image.url
          images.push url if url
        images

      carouselOptions: ->
        opts =
          height: '200px'
          spaceBetweenSlides: '0px'
          perPage: 1
          loop: true
          navigationPrevLabel: '<span class="flex items-center justify-center -ml-5 w-8 h-8 text-white opacity-75 hover:opacity-100 custom-text-shadow"><i class="fas fa-chevron-left text-2xl"></i></span>'
          navigationNextLabel: '<span class="flex items-center justify-center -mr-5 w-8 h-8 text-white opacity-75 hover:opacity-100 custom-text-shadow"><i class="fas fa-chevron-right text-2xl"></i></span>'
          displayGallery: false
        opts



      location: -> @event?.venue?.location || {}

    methods:
      navigateToDetails: ->
        routeName = 'EventFeedDetails'
        routeName = 'CheckoutEventDetails' if @$route.name is 'CheckoutPage'
        @$router.push { name: routeName, params: { eventId: @event.id } }
      navigateToInstanceDetails: (instanceId) ->
        @$router.push({ name: 'EventFeedDetails', params: { eventId: instanceId } })

      formatDateForEvent: (event) ->
        @$options.filters.formatDateWindow(event.local_start_day, event.local_end_day)

      hiFavoriteEventTrigger: -> @actions.favoriteEventTrigger @event
      hiUnfavoriteEventTrigger: -> @actions.unfavoriteEventTrigger @event


export default VueOptions.vue settings
